export function getAddressTypeNameByAddressTypeId (address_types = [], id, default_value = '') {

	const { name: address_type_name = default_value } = (address_types.find(({address_type_id}) => address_type_id === id) ?? {})

	return address_type_name

}
